import { INITIAL_STATE } from './data'
import { ActionProps, IReduxAppConfig } from './props'

export default function reducer(
  state = INITIAL_STATE[0],
  action: ActionProps
): IReduxAppConfig {
  if (action.type === 'SET_APP_CONFIG') {
    return {
      ...state,
      appConfig: action.appConfig,
    }
  }

  return {}
}
